import { ValueObject } from '@nx-smartmonkey/shared/domain';

export interface ProjectResourcesProps {
  vehicles: number;
  supervisors: number;
  max_clients: number;
  max_stops_plan: number;
  max_vehicles_plan: number;
  traffic?: boolean;
}

export class ProjectResources extends ValueObject<ProjectResourcesProps> {
  private constructor(props: ProjectResourcesProps) {
    super(props);
  }

  static create(props: ProjectResourcesProps): ProjectResources {
    return new ProjectResources(props);
  }

  get vehicles(): number {
    return this.props.vehicles;
  }

  get supervisors(): number {
    return this.props.supervisors;
  }

  get max_clients(): number {
    return this.props.max_clients;
  }

  get max_stops_plan(): number {
    return this.props.max_stops_plan;
  }

  get max_vehicles_plan(): number {
    return this.props.max_vehicles_plan;
  }

  get traffic(): boolean {
    return this.props.traffic || false;
  }
}
